import type {
  DisplayName,
  EngagementRemoteFilterShellsResult,
} from "@dashboardApi/apis/engagementRemoteFilterShells";

/**
 * Narrows a shell's display name to its rich object form.
 *
 * @param shell - A remote filter shell, the placeholder value used for error states, or nothing
 * when no shell is selected.
 * @returns The rich display name, or undefined when the shell is absent or uses a plain string name.
 */
export const getRichDisplayName = (
  shell: EngagementRemoteFilterShellsResult | undefined
): DisplayName | undefined => {
  if (!shell || typeof shell.display_name === "string") {
    return undefined;
  }
  return shell.display_name;
};
